import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { PLATFORM_URL } from '../config/constants';

const routeToFeatureName = {
  '/homepage': 'HomePage',
  '/activities': 'Activities',
  '/products': 'Products',
  '/services': 'Services',
  '/about': 'About',
  '/contact': 'Contact',
  '/help': 'Help',
  '/login': 'Login',
  '/': 'Login'
};

/**
 * Checks if the app is running inside an iframe (native tab)
 */
function isInNativeTab() {
  return window.location !== window.parent.location;
}

/**
 * LocationReporter component
 * Reports location changes to the parent platform when running in a native tab
 * This enables proper navigation (forward/back buttons, page refresh restoration, tab reopening)
 */
function LocationReporter() {
  const location = useLocation();

  useEffect(() => {
    // Only report location changes when running inside a native tab
    if (!isInNativeTab()) {
      return;
    }

    const message = {
      type: 'LocationChanged',
      url: window.location.href,
      title: {
        featureName: routeToFeatureName[location.pathname] || 'Unknown'
      }
    };

    window.parent.postMessage(JSON.stringify(message), PLATFORM_URL);
  }, [location]);

  return null;
}

export default LocationReporter;
